import { combineReducers } from 'redux';
import { singleValueReducer } from 'store/reducerUtils';
import { setEditTravelExpenseId } from 'modules/travelExpenses/components/Edit/store/actions';

const travelExpenseId = singleValueReducer(setEditTravelExpenseId.action, null as string | null);

export const editTravelExpense = combineReducers({
    travelExpenseId,
});
